import script from "./DocumentBatchCreate.vue?vue&type=script&lang=ts&setup=true"
export * from "./DocumentBatchCreate.vue?vue&type=script&lang=ts&setup=true"

import "./DocumentBatchCreate.vue?vue&type=style&index=0&id=199d611a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-199d611a"]])

export default __exports__